import * as Phaser from 'phaser';
import { mountRotateNudge } from '@learnforge/demo-kit';
import { init as initI18n, setLang as setLangApi } from './i18n';
import { getSDK } from './sdk-bridge';
import { HowToPlayScene } from './scene/HowToPlayScene';
import { HowToPlayColorScene } from './scene/HowToPlayColorScene';
import { MenuScene } from './scene/MenuScene';
import { OptionsScene } from './scene/OptionsScene';
import { PuzzleScene } from './scene/PuzzleScene';
import { parseLevel } from './level/loader';
import lvl01 from './level/data/01-intro.json';
import lvl02 from './level/data/02-two-mirrors.json';
import lvl03 from './level/data/03-corner.json';
import lvl04 from './level/data/04-two-targets.json';
import lvl05 from './level/data/05-tight.json';
import lvl06 from './level/data/06-hello-color.json';
import lvl07 from './level/data/07-pick-a-side.json';
import lvl08 from './level/data/08-yellow.json';
import lvl09 from './level/data/09-magenta.json';
import lvl10 from './level/data/10-spectrum.json';

const ALL_LEVELS = [lvl01, lvl02, lvl03, lvl04, lvl05, lvl06, lvl07, lvl08, lvl09, lvl10];

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game',
  backgroundColor: '#0a0a14',
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: 960,
    height: 720,
  },
  scene: [MenuScene, HowToPlayScene, HowToPlayColorScene, OptionsScene, PuzzleScene],
};

initI18n();
mountRotateNudge();
// Pre-warm the SDK handshake. The result isn't currently displayed, but
// kicking off `getUser` at boot lets the platform host wire up user context
// before any gameplay scene needs it — and acts as the contract handshake
// that apps/platform/e2e/sdk-contract.spec.ts polls for.
void getSDK().getUser();
const game = new Phaser.Game(config);

if (typeof window !== 'undefined' && new URLSearchParams(window.location.search).has('e2e')) {
  (window as unknown as { __luminary_e2e_forceWin?: () => void }).__luminary_e2e_forceWin = () => {
    const scene = game.scene.getScene('puzzle') as { forceWinForTest?: () => void } | null;
    scene?.forceWinForTest?.();
  };

  (window as unknown as { __luminary_setLang?: (code: string) => void }).__luminary_setLang = (
    code: string,
  ) => setLangApi(code as never);

  const marker = document.createElement('div');
  marker.id = 'e2e-state';
  marker.setAttribute('data-scene', 'boot');
  document.body.appendChild(marker);

  game.events.once('ready', () => {
    const params = new URLSearchParams(window.location.search);
    const requestedId = params.get('level');
    const data = ALL_LEVELS.find((l) => (l as { id: string }).id === requestedId) ?? lvl01;
    const level = parseLevel(data);
    game.scene.start('puzzle', { level });
    marker.setAttribute('data-scene', 'puzzle');
  });
}
